import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useFetch } from '../hooks/useApiCall';
import { getLoyaltyProgress } from '../services/loyaltyService';
import { PmLoading, PmError, PmEmpty } from '../components/pm/PmStates';
import { IconBadgeCheck, IconCheck, IconArrow } from '../components/pm/PmIcons';
import { BUSINESS, ROUTES } from '../data/pmContent';

const LoyaltyProgress = () => {
  const { data: loyalty, loading, error, refetch } = useFetch(getLoyaltyProgress);

  const stamps = loyalty?.stamps || 0;
  const required = loyalty?.stamps_required || 10;
  const pct = Math.min(100, Math.round((stamps / required) * 100));

  return (
    <div className="pm-scope account">
      <Helmet>
        <title>Programa de fidelidad - {BUSINESS.name}</title>
      </Helmet>

      <section className="section">
        <div className="container container--narrow">
          <header className="account__head">
            <div>
              <span className="eyebrow">Tu cuenta</span>
              <h1>Programa de fidelidad</h1>
              <p>Acumula sellos con cada visita y canjéalos por servicios.</p>
            </div>
            <Link to={ROUTES.agendar} className="btn btn--primary">
              Agendar cita <IconArrow />
            </Link>
          </header>

          {loading && <PmLoading message="Cargando tu progreso…" />}
          {error && <PmError message={error} onRetry={refetch} />}

          {!loading && !error && !loyalty && (
            <PmEmpty
              icon={IconBadgeCheck}
              title="Aún no estás inscrita en el programa"
              text="Visita el estudio para comenzar a acumular sellos. Se registran automáticamente en tu cuenta."
              action={<Link to={ROUTES.agendar} className="btn btn--primary">Agendar mi primera cita</Link>}
            />
          )}

          {loyalty && (
            <>
              <div className="acct-grid acct-grid--2">
                <article className="acct-card acct-card--center">
                  <span className="acct-label">Sellos acumulados</span>
                  <div className="loyalty-count">
                    <strong>{stamps}</strong>
                    <span>/ {required}</span>
                  </div>
                  <div className="progress" role="progressbar" aria-valuenow={pct} aria-valuemin="0" aria-valuemax="100" aria-label="Progreso de sellos">
                    <span style={{ width: `${pct}%` }} />
                  </div>
                  {required <= 20 && (
                    <div className="stamps" aria-hidden="true">
                      {Array.from({ length: required }, (_, i) => (
                        <span key={i} className={i < stamps ? 'is-filled' : ''}><IconCheck width="14" height="14" strokeWidth="3" /></span>
                      ))}
                    </div>
                  )}
                  <p style={{ fontSize: 'var(--fs-sm)' }}>
                    {loyalty.stamps_remaining > 0
                      ? `Te faltan ${loyalty.stamps_remaining} sellos para tu premio`
                      : '¡Felicidades! Completaste tu tarjeta de fidelidad'}
                  </p>
                </article>

                <article className="acct-card acct-card--center">
                  <span className="acct-label">Nivel</span>
                  <div className="loyalty-level">{loyalty.level || 'Bronce'}</div>
                  {loyalty.reward && (
                    <span className="chip chip--completed">Premio: {loyalty.reward}</span>
                  )}
                  <p style={{ fontSize: 'var(--fs-sm)' }}>
                    Sigue acumulando sellos para desbloquear beneficios exclusivos.
                  </p>
                </article>
              </div>

              {loyalty.history && loyalty.history.length > 0 && (
                <div style={{ marginTop: 'var(--space-7)' }}>
                  <span className="acct-label">Historial de sellos</span>
                  <ul className="acct-history">
                    {loyalty.history.map((stamp, index) => (
                      <li key={index}>
                        <span>{stamp.service || 'Servicio'}</span>
                        <span>{stamp.date ? new Date(stamp.date).toLocaleDateString('es-DO') : ''}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default LoyaltyProgress;
